import PageHeader from "../../components/common/PageHeader";
import Table from "../../components/common/Table";
import StatusBadge from "../../components/common/StatusBadge";
import { formatDate } from "../../utils/HelperMethod";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/common/Pagination";
import SearchBar from "../../components/common/Search";
import CustomFilterDropdown from "../../components/common/CustomFilterDropdown";
import ActionMenu from "../../components/common/ActionMenu";
import { AiOutlineEye } from "react-icons/ai";
import { useAdminUsers } from "../../custom-hooks/queries";

const statusOptions = [
  { id: "Approved", name: "Approved" },
  { id: "Pending", name: "Pending" },
  { id: "Suspended", name: "Suspended" },
];

export default function UserManagement() {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageSize = 10;

  const statusOptions = [
    { id: "Approved", name: "Approved" },
    { id: "Pending", name: "Pending" },
    { id: "Suspended", name: "Suspended" },
  ];

  const { data, isLoading, isError } = useAdminUsers({
    page: currentPage,
    pageSize,
    search: searchText,
    status: statusFilter,
  });

  const users =
    data?.data?.data?.data?.map((item) => ({
      userId: item.userId,
      name: item.firstName + " " + item.lastName,
      email: item.email,
      status: item.status,
      createdAt: item.createdAt,
    })) || [];

  const userActions = (row) => [
    {
      label: "View User",
      icon: <AiOutlineEye />,
      onClick: () => navigate(`/admin/users/${row.userId}`),
    },
  ];

  const columns = [
    {
      key: "name",
      label: "NAME",
      width: "1.8fr",
      align: "left",
      render: (row) => (
        <div className="font-semibold text-gray-900 truncate">{row.name}</div>
      ),
    },
    {
      key: "email",
      label: "EMAIL",
      width: "2fr",
      align: "left",
      render: (row) => (
        <div className="text-gray-700 truncate">{row.email}</div>
      ),
    },
    {
      key: "status",
      label: "STATUS",
      width: "1.2fr",
      align: "center",
      render: (row) => <StatusBadge status={row.status} />,
    },
    {
      key: "createdAt",
      label: "CREATED ON",
      width: "1.4fr",
      align: "center",
      render: (row) => (
        <span className="text-sm text-gray-600">
          {formatDate(row.createdAt)}
        </span>
      ),
    },
    {
      key: "actions",
      label: "ACTIONS",
      width: "1fr",
      align: "center",
      render: (row) => <ActionMenu actions={userActions(row)} />,
    },
  ];

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handleStatusChange = (statusId) => {
    setStatusFilter(statusId);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="px-4 py-1 sm:px-6 sm:py-1">
      <PageHeader
        title="User Management"
        description="Manage and monitor platform users"
      />

      <div className="bg-white rounded-[12px] border border-[#D9D9D9] shadow-sm overflow-hidden mt-4 sm:mt-6">
        {/* 🔍 Search + Filter */}
        <div className="flex flex-col sm:flex-row justify-between gap-4 py-6 sm:py-10 px-4 sm:px-6">
          <SearchBar onSearch={handleSearch} />

          <CustomFilterDropdown
            options={statusOptions}
            onChange={handleStatusChange}
            placeholder="Filter by Status"
            valueKey="id"
            labelKey="name"
          />
        </div>

        {isError ? (
          <div className="flex justify-center items-center py-20 text-red-500">
            Failed to load users.
          </div>
        ) : (
          <Table
            columns={columns}
            data={users}
            isLoading={isLoading}
            skeletonRows={pageSize}
          />
        )}
      </div>

      {!isLoading && !isError && data?.data?.data?.totalPages > 1 && (
        <div className="mt-4 sm:mt-6">
          <Pagination
            currentPage={currentPage}
            totalPages={data?.data?.data?.totalPages || 1}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
}
